import { useTranslation } from 'react-i18next';

import { ROUTES } from '@shared/config/routes';
import { ButtonLink, Container } from '@shared/ui';

import styles from './NotFoundPage.module.css';

/**
 * 404 — та же карточка по центру, что у страницы входа (DESIGN_SYSTEM §5.2):
 * служебные экраны публичной части читаются как одна вещь.
 *
 * Красная кнопка одна — «на главную» (§5.1); второе действие вторично.
 */
export function NotFoundPage() {
  const { t } = useTranslation();

  return (
    <section className={styles.page}>
      <Container width="narrow" className={styles.inner}>
        <div className={styles.card}>
          {/* Код ошибки — надзаголовок, а не крупная красная цифра: красный на
              экране зовёт к действию, а не сообщает об ошибке (§2.2). */}
          <p className={`${styles.code} tabular`}>{t('notFound.code')}</p>
          <h1 className={styles.title}>{t('notFound.title')}</h1>
          <p className={styles.text}>{t('notFound.description')}</p>
          <div className={styles.actions}>
            <ButtonLink to={ROUTES.home}>{t('notFound.home')}</ButtonLink>
            <ButtonLink to={ROUTES.app} variant="secondary">
              {t('nav.mySearches')}
            </ButtonLink>
          </div>
        </div>
      </Container>
    </section>
  );
}
